import { createFileRoute, notFound } from "@tanstack/react-router";

import { devicesDataTriggerQueries } from "@/api/resources/deviceDataTriggers/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import DeviceDataTriggerPage from "@/components/DeviceDataTrigger/DeviceDataTriggerPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: `${i18n.t("navigation.device-data")} - ${i18n.t("device-data-trigger")}`,
        icon: <Icon.DEVICE_DATA_TRIGGER />,
        path: "/workspaces/$workspace_id/device-data/triggers",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, device_data_trigger_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDeviceDataTrigger = await context.queryClient.ensureQueryData(
      devicesDataTriggerQueries.byId(device_data_trigger_id),
    );
    if (!currentDeviceDataTrigger) throw notFound();

    return currentDeviceDataTrigger;
  },
  component: DeviceDataTriggerPage,
});
